mutation MigrateMutation($id: ID!) {
  migrate(id: $id)
}
